import styled from 'styled-components';

export const ReviewsContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f5f7fa;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 280px;
  
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

export const Header = styled.div`
  background: white;
  padding: 20px 32px;
  border-bottom: 1px solid #e8eaed;

  @media (max-width: 1024px) {
    padding: 16px 20px;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`;

export const HeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

export const HeaderTitle = styled.div``;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #202124;
  margin: 0 0 4px 0;

  @media (max-width: 1024px) {
    font-size: 22px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const Subtitle = styled.p`
  font-size: 14px;
  color: #5f6368;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const UpdateButton = styled.button`
  padding: 10px 24px;
  background: #1a73e8;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  .material-icons {
    font-size: 18px;
  }

  &:hover {
    background: #1557b0;
  }

  @media (max-width: 1024px) {
    padding: 8px 20px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 13px;

    .material-icons {
      font-size: 16px;
    }
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
  border-bottom: 2px solid #e8eaed;
  overflow-x: auto;

  @media (max-width: 768px) {
    gap: 4px;
  }
`;

export const Tab = styled.button<{ $active?: boolean }>`
  padding: 12px 20px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  color: ${props => props.$active ? '#1a73e8' : '#5f6368'};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: -2px;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  ${props => props.$active && `
    border-bottom-color: #1a73e8;
    color: #1a73e8;
  `}

  &:hover {
    color: #1a73e8;
    background: #f8f9fa;
  }

  @media (max-width: 1024px) {
    padding: 10px 16px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    padding: 10px 12px;
    font-size: 13px;
    gap: 6px;
  }
`;

export const TabCount = styled.span`
  background: ${props => props.color || '#e8f0fe'};
  color: #1a73e8;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

export const FiltersBar = styled.div`
  background: white;
  padding: 16px 32px;
  border-bottom: 1px solid #e8eaed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    padding: 12px 20px;
    gap: 12px;
  }

  @media (max-width: 768px) {
    padding: 12px 16px;
    gap: 8px;
  }
`;

export const FilterButton = styled.button`
  padding: 8px 16px;
  background: white;
  border: 1px solid #dadce0;
  border-radius: 8px;
  color: #3c4043;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    border-color: #bdc1c6;
  }

  @media (max-width: 1024px) {
    padding: 7px 14px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 13px;
    gap: 6px;
  }
`;

export const FilterIcon = styled.span`
  font-size: 18px;
  color: #5f6368;
`;

export const SortSelect = styled.select`
  padding: 8px 16px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 14px;
  color: #3c4043;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #bdc1c6;
  }

  &:focus {
    outline: none;
    border-color: #1a73e8;
  }

  @media (max-width: 1024px) {
    padding: 7px 14px;
    font-size: 13px;
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 13px;
    width: 100%;
  }
`;

export const ReviewsList = styled.div`
  flex: 1;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;

  @media (max-width: 1024px) {
    padding: 16px 20px;
    gap: 12px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    gap: 12px;
  }
`;

export const ReviewCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px 24px;
  border: 1px solid #e8eaed;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1024px) {
    padding: 16px 20px;
  }

  @media (max-width: 768px) {
    padding: 16px;
    border-radius: 8px;
  }
`;

export const ReviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const ReviewAuthor = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const AuthorAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #4285f4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  font-weight: 600;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }
`;

export const AuthorInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AuthorName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #202124;
  margin-bottom: 2px;
`;

export const RatingStars = styled.div`
  display: flex;
  gap: 2px;

  .material-icons {
    font-size: 16px;
    color: #fbbc04;
  }
`;

export const ReviewDate = styled.span`
  font-size: 12px;
  color: #5f6368;
`;

export const ReviewContent = styled.div`
  margin-bottom: 16px;
`;

export const ReviewText = styled.p`
  font-size: 14px;
  line-height: 1.6;
  color: #3c4043;
  margin: 0;
`;

export const ResponseSection = styled.div`
  margin-top: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 3px solid #1a73e8;

  @media (max-width: 1024px) {
    padding: 14px;
  }

  @media (max-width: 768px) {
    padding: 12px;
    margin-top: 12px;
  }
`;

export const ResponseLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1a73e8;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;

  .material-icons {
    font-size: 16px;
  }
`;

export const ResponseText = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #5f6368;
  margin-bottom: 12px;
`;

export const ResponseActions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ActionButton = styled.button<{ variant?: 'primary' | 'secondary' | 'danger' | 'ai' }>`
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;

  .material-icons {
    font-size: 16px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }

  @media (max-width: 1024px) {
    padding: 7px 14px;
    font-size: 12px;
  }

  @media (max-width: 768px) {
    padding: 6px 12px;
    font-size: 12px;
    gap: 4px;

    .material-icons {
      font-size: 14px;
    }
  }

  ${props => {
    switch (props.variant) {
      case 'primary':
        return `
          background: #1a73e8;
          color: white;
          &:hover {
            background: #1557b0;
          }
        `;
      case 'danger':
        return `
          background: white;
          color: #ea4335;
          border: 1px solid #dadce0;
          &:hover {
            background: #fce8e6;
          }
        `;
      case 'ai':
        return `
          background: #4285f4;
          color: white;
          box-shadow: 0 2px 4px rgba(66, 133, 244, 0.2);
          &:hover {
            background: #1a73e8;
            box-shadow: 0 4px 8px rgba(66, 133, 244, 0.3);
            transform: translateY(-1px);
          }
        `;
      default:
        return `
          background: white;
          color: #1a73e8;
          border: 1px solid #dadce0;
          &:hover {
            background: #f8f9fa;
          }
        `;
    }
  }}
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #dadce0;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  color: #3c4043;
  resize: vertical;
  transition: border 0.2s ease;
  margin-bottom: 12px;

  &:focus {
    outline: none;
    border-color: #1a73e8;
  }

  &::placeholder {
    color: #9aa0a6;
  }

  &:disabled {
    background: #f8f9fa;
    color: #9aa0a6;
    cursor: not-allowed;
  }
`;

// Modal de Filtros
export const FiltersModal = styled.div<{ $isOpen: boolean }>`
  display: ${props => props.$isOpen ? 'block' : 'none'};
`;

export const FiltersModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 0;
    align-items: flex-end;
  }
`;

export const FiltersModalContent = styled.div`
  background: white;
  border-radius: 12px;
  max-width: 500px;
  width: 100%;
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    max-width: 100%;
    max-height: 90vh;
    border-radius: 12px 12px 0 0;
  }
`;

export const FiltersModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #e8eaed;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const FiltersModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #202124;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }

  .material-icons {
    font-size: 20px;
    color: #5f6368;
  }
`;

export const FiltersModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const FilterGroup = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const FilterLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #3c4043;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #3c4043;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s ease;

  &:hover {
    background: #f8f9fa;
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #1a73e8;
  }
`;

export const DateInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 14px;
  color: #3c4043;
  transition: border 0.2s ease;

  &:focus {
    outline: none;
    border-color: #1a73e8;
  }
`;

export const FiltersModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e8eaed;
  display: flex;
  justify-content: space-between;
  gap: 12px;

  @media (max-width: 768px) {
    padding: 12px 16px;
    flex-direction: column-reverse;
  }
`;

export const ApplyButton = styled.button`
  flex: 1;
  padding: 10px 24px;
  background: #1a73e8;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #1557b0;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
  }
`;

export const ClearFiltersButton = styled.button`
  padding: 10px 24px;
  background: white;
  color: #5f6368;
  border: 1px solid #dadce0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8f9fa;
    border-color: #bdc1c6;
  }

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 13px;
    flex: 1;
  }
`;
